import { AnnotationConstant } from "Constants/AnnotationConstants";
import AppColorStore from "Stores/AppColor/AppColorStore";
import { connect } from 'react-redux';
import { FibonacciLineControl } from '../Presentational/index';
import {
    handleDragStart, handleDragMove, handleDragEnd, handleDeleteAnnotationDrawing, handleToggleContextMenu,
    handleAnchorDragStart, handleAnchorDragEnd, handleAnchorDragMove
} from '../../../../../../Actions/AnnotationActions';
import React, { Component } from 'react';
const { ActionTypes } = AnnotationConstant;

class GraphicsFibonacci extends Component {

    componentDidMount() {
        AppColorStore.addChangeListener(this.AppColorStoreStateChanged);
    }

    componentWillUnmount() {
        AppColorStore.removeChangeListener(this.AppColorStoreStateChanged);
    }

    AppColorStoreStateChanged = () => {

        this.forceUpdate();
    }

    render() {
        const { fibonacciLine, index, lockImage, isApiReqResolved } = this.props;
        const { isDragging, activeAnchor, selectedAnnotId, annotationDimension } = this.props.annotationChartModelReducer;

        return (

            <FibonacciLineControl
                key={index}
                index={index}
                fibonacciLine={fibonacciLine}
                isDragging={isDragging}
                activeAnchor={activeAnchor}
                selectedAnnotId={selectedAnnotId}
                annotationDimension={annotationDimension}
                handleDragStart={this.props.handleDragStart}
                handleDragMove={this.props.handleDragMove}
                handleDragEnd={this.props.handleDragEnd}
                handleAnchorDragStart={this.props.handleAnchorDragStart}
                handleAnchorDragEnd={this.props.handleAnchorDragEnd}
                handleAnchorDragMove={this.props.handleAnchorDragMove}
                onContextMenu={this.props.onContextMenu}
                draggable={this.props.draggable}
                lockImage={lockImage}
                isApiReqResolved={isApiReqResolved}
                handleDeleteAnnotationDrawing={this.props.handleDeleteAnnotationDrawing}
            />
        );
    }
}

const mapStateToProps = ({ annotationReducers }) => {
    const { fibonacciLineReducer, annotationChartModelReducer } = annotationReducers;
    return ({ fibonacciLineReducer, annotationChartModelReducer });
}

const mapDispatchToProps = (dispatch) => ({
    handleDragStart: (fibLine) => dispatch(handleDragStart(fibLine)),
    handleDragMove: (e, isEndExtend, isStartExtend, isStartArrow, isEndArrow, isLabel) => dispatch(handleDragMove(e, isEndExtend, isStartExtend, isStartArrow, isEndArrow, isLabel)),
    handleDragEnd: () => handleDragEnd(),
    handleAnchorDragStart: (anchor) => dispatch(handleAnchorDragStart(anchor)),
    handleAnchorDragEnd: () => handleAnchorDragEnd(),
    handleAnchorDragMove: (e) => dispatch(handleAnchorDragMove(e, ActionTypes.HANDLE_FIBONACCI_LINE_DRAW)),
    handleDeleteAnnotationDrawing: (charCode) => { dispatch(handleDeleteAnnotationDrawing(charCode)), dispatch(handleToggleContextMenu(false, 0, 0, '')) }
});

export default connect(mapStateToProps, mapDispatchToProps)(GraphicsFibonacci);